<template>
  <div class="card-main-clone mx-20 mb-8 mt-6 px-6">
    <div class="mt-2 sm:col-span-2 sm:mt-2">
      <div
        v-if="!isUser"
        class="mb-2 sm:w-full"
      >
        <input
          id="name"
          v-model="signupForm.name"
          type="text"
          name="name"
          :placeholder="$t('enter_your_name')"
          autocomplete="off"
          class="
                    xl:w-90
                    lg:w-70
                    md:w-100
                    block h-10
                    rounded-lg
                    border-gray-300
                    text-gray-800
                    shadow-sm
                    focus:border-primary-900
                    focus:ring-primary-900
                    sm:w-full
                    sm:text-sm
                "
        >
        <p
          v-for="(error,index) in signupErrors.name"
          :key="index"
          class="m-2 text-xs text-red-700"
        >
          {{ error }}
        </p>
      </div>

      <div class="sm:w-full">
        <input
          id="email"
          v-model="signupForm.email"
          type="text"
          :placeholder="$t('enter_your_email')"
          autocomplete="off"
          class="
                    xl:w-90
                    lg:w-70
                    md:w-100
                    block h-10
                    rounded-lg
                    border-gray-300
                    text-gray-800
                    shadow-sm
                    focus:border-primary-900
                    focus:ring-primary-900
                    sm:w-full
                    sm:text-sm
                "
          :class="{
            'w-80': !isUser,
            'w-full': isUser,
          }"
        >
        <p
          v-for="(error,index) in signupErrors.email"
          :key="index"
          class="m-2 text-xs text-red-700"
        >
          {{ error }}
        </p>
      </div>

      <input
        v-if="isUser"
        id="password"
        v-model="signupForm.password"
        type="password"
        :placeholder="$t('password')"
        class="
                    mt-2
                    block
                    h-10
                    w-full
                    rounded-lg
                    border-gray-300 text-gray-800
                    shadow-sm
                    focus:border-primary-900
                    focus:ring-primary-900
                    sm:text-sm
                "
      >

      <button
        :disabled="!signupForm.email || !signupForm.name || cloning!='init'"
        type="button"
        class="
                bg-insta-primary
                hover:bg-insta-primary-dark
                primarySettings
                mt-2
                inline-flex
                w-full justify-center
                rounded-md
                border
                border-transparent
                px-4
                py-2
                text-base
                font-medium
                text-white
                shadow-sm
                focus:outline-none focus:ring-2 focus:ring-secondary-800
                focus:ring-offset-2
                disabled:opacity-50
                sm:col-start-2 sm:text-base
                "
        @click="createUser()"
      >
        <svg
          v-if="cloning == 'inProcess'"
          class="-ml-1 mr-3 size-5 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <span>{{ isUser ? $t('verify_account') : $t('copy_this_site') }}</span>
      </button>
    </div>
    <p
      v-if="signupErrors.site"
      class="m-2 text-xs text-red-700"
    >
      {{ signupErrors.site }}
    </p>
  </div>
</template>

<script>

export default {
    name: "Clone",
    props:{
        signupForm: {
            type: Object,
        },
        signupErrors: {
            type: Object,
        },
        isUser: {
            type: Boolean,
        },
        cloning: {
            type: String,
        },
        displaySettings: {
            type: Object,
            default: {
                primaryColor: '#15B881',
                accentColor: '#ffffff',
            },
        }
    },
    
    methods: {
        createUser() {
            this.$emit('createUser');
        }
    }
}
</script>

<style scoped>
.primarySettings {
    background-color: v-bind('displaySettings.primaryColor');
    color: v-bind('displaySettings.accentColor');
}
.card-main-clone{
    background: #FFFFFF;
    width: 562px;
    padding: 28px;
    margin: auto;
    border-radius: 0 0 8px 8px;
}
</style>